var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7553 7.38C20.5799 6.41234 19.7446 5.70766 18.7753 5.48766C17.3246 5.18 14.6399 4.96 11.7353 4.96C8.83229 4.96 6.10463 5.18 4.65229 5.48766C3.68463 5.70766 2.8476 6.36766 2.67229 7.38C2.49526 8.48 2.31995 10.02 2.31995 12C2.31995 13.98 2.49526 15.52 2.71526 16.62C2.89229 17.5877 3.7276 18.2923 4.69526 18.5123C6.23526 18.82 8.87526 19.04 11.7799 19.04C14.6846 19.04 17.3246 18.82 18.8646 18.5123C19.8323 18.2923 20.6676 17.6323 20.8446 16.62C21.0199 15.52 21.2399 13.9353 21.2846 12C21.1953 10.02 20.9753 8.48 20.7553 7.38ZM9.35995 15.08V8.92L14.7276 12L9.35995 15.08Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconYoutube);
export default __webpack_public_path__ + "static/media/icon-youtube.0883dbad4643d594ea0ee4b2e8b487ca.svg";
export { ForwardRef as ReactComponent };